<div *ngIf="libraries">
  <p>Bitte wählen Sie die gewünschte Bibliothek</p>
  <ng-select
    focusInput
    class="form-control ng-select-white"
    [(ngModel)]="library"
    [items]="libraries"
    placeholder="Bibliothek auswählen"
    *ngIf="!IsTesting"
    (keydown.enter)="FormAutomation.FocusNextChild($event)"
  >
  </ng-select>

  <div *ngIf="!isConnected">
    <p>
      Der Schulio-Server ist nicht erreichbar. Bitte überprüfen Sie Ihre
      Internet&shy;verbindung.
    </p>
  </div>

  <button
    id="submit"
    class="btn btn-block form-control"
    [class.d-none]="!library"
    @inAnimation
    (click)="execLogin()"
    *ngIf="!loading"
    [disabled]="!isConnected"
  >
    Weiter
  </button>
  <button
    id="loading"
    class="btn btn-block form-control"
    [class.d-none]="!library"
    @inAnimation
    disabled
    *ngIf="loading"
  >
    Lädt ...
  </button>
</div>
